{
  "(optional)": "(valgfrit)",
  "(required)": "(obligatorisk)"
}
